/**
 * Views Routers
 */
import DashboardRoutes from '@/views/Dashboard/router';
import UserRoutes from '@/views/User/router';
import CustomerRoutes from '@/views/Customer/router';
import PartnerRoutes from '@/views/Partner/router';
import ApplicationInstanceRoutes from '@/views/ApplicationInstance/router';

const routes = [
  {
    path: '/',
    redirect: '/Inicio',
    name: 'TheMain',
    component: 'Main/TheMain',
    children: [
      ...DashboardRoutes,
      ...UserRoutes,
      ...CustomerRoutes,
      ...PartnerRoutes,
      ...ApplicationInstanceRoutes
    ]
  }
];

export default routes;
